import bus from "../bus";
import { playerEvents } from "../player/events";
import decoratePlayerItem from "../player/playables/decorate";
import { mergeStateAction } from "../utilities/hyperapp";

function wouldUpdateState(currentState, newAttrs) {
  for (const [k, v] of Object.entries(newAttrs)) {
    if (currentState[k] !== v) {
      return true;
    }
  }

  return false;
}

export default {
  destroy: () => mergeStateAction({ destroyed: true }),
  set: partialState => partialState,
  setPlaying: isPlaying => mergeStateAction({ isPlaying }),
  setCurrentItem: isCurrentItem => mergeStateAction({ isCurrentItem }),
  decorateItems: () => async (state, actions) => {
    Promise.all(
      state.items.map(item => decoratePlayerItem(item, { refreshID: true }))
    ).then(decoratedItems => {
      actions.set({ items: decoratedItems });
    });
  },
  onCreate: () => (state, actions) => {
    // Try to decorate items in advance of being added to the player
    if (window.requestIdleCallback) {
      window.requestIdleCallback(actions.decorateItems);
    } else {
      actions.decorateItems();
    }
    bus.emit(playerEvents.REQUEST_STATUS);
    bus.on(playerEvents.STATUS_CHANGE, actions.onPlayerStatusChange);
    bus.on(playerEvents.TIME_UPDATE, actions.onTimeUpdate);
  },
  onDestroy: () => (state, actions) => {
    bus.removeListener(
      playerEvents.STATUS_CHANGE,
      actions.onPlayerStatusChange
    );
    bus.removeListener(playerEvents.TIME_UPDATE, actions.onTimeUpdate);
  },
  onPlayerStatusChange: ({
    currentItemPlayerItemID,
    currentTargetType,
    status
  }) => (state, actions) => {
    const { items } = state;
    const currentItem = items.find(
      item => item.playable_id == currentItemPlayerItemID
    );
    const isSameType = items.find(
      item =>
        (item.type === "stream" && currentTargetType === "stream") ||
        (item.type !== "stream" && currentTargetType !== "stream")
    );
    if (currentItem != null && isSameType != null) {
      actions.setCurrentItem(true);
      actions.setPlaying(status === "playing");
    } else {
      actions.setCurrentItem(false);
      actions.setPlaying(false);
    }
  },
  onTimeUpdate: timeValues => (state, actions) => {
    if (state.isCurrentItem) {
      if (wouldUpdateState(state, timeValues)) {
        actions.set(timeValues);
      }
    }
  }
};
